import React from 'react'
import Error from '../../components/Error'
import Title from '../../components/Title'
import Footer from '../../components/Footer'
import useT from '../../components/Traduction'


function Error404() {
    const t = useT()
    return (
        <>
            <div className="min-height">
                <Title titleName={t("Page_not_found")}/>
                <Error errorCode="404" errorText={t("Page_not_found_message")}/>
            </div>
            <Footer />
        </>
    )
  }  

export default Error404